// hotelConfig.js

// Marques alignées sur SCOPE_MASTER ; seules celles avec image dans img/simulator sont listées (ex. MULTI-BRANDS & OTHERS, NOVOTEL SUITES exclus).
export const segmentHotelMapping = {
  Économique: ["Adagio_Access", "Breakfree", "greet", "hotelF1", "ibis", "ibis_Budget", "ibis_Styles", "JO&JOE"],
  "Milieu de gamme": ["Adagio_Original", "Handwritten", "Mantra", "Mercure", "Novotel", "Tribe", "Mama_Shelter"],
  Premium: ["Adagio_Premium", "Art_Series", "Grand_Mercure", "Mantis", "Mövenpick", "Peppers", "Pullman", "Swissotel", "The_Sebel", "21C", "25_Hours", "Hoxton", "Hyde", "Mondrian"],
  "Luxe / Premium Luxe": ["Banyan_Tree", "Delano", "Faena", "Gleneagles", "Our_Habitas", "Redbury_Hotels", "Rixos", "SLS", "So", "The_Originals", "Fairmont", "Emblems", "Sofitel", "Orient_Express", "Raffles", "MGallery"],
};

// On regroupe les marques par leur type principal pour les calculs
export const hotelTypeEquivalence = {
  // Segment ÉCONOMIQUE → profil de référence = Ibis Styles
  ibis: "Ibis Styles",
  ibis_Styles: "Ibis Styles",
  ibis_Budget: "Ibis Styles",
  greet: "Ibis Styles",
  hotelF1: "Ibis Styles",
  "JO&JOE": "Ibis Styles",
  Adagio_Access: "Ibis Styles",
  Breakfree: "Ibis Styles",

  Novotel: "Novotel",
  Mercure: "Novotel",
  Adagio_Original: "Novotel",
  Tribe: "Novotel",
  Mama_Shelter: "Novotel",
  Handwritten: "Novotel",
  Mantra: "Novotel",

  Pullman: "Molitor",
  Mövenpick: "Molitor",
  Adagio_Premium: "Molitor",
  Art_Series: "Molitor",
  Grand_Mercure: "Molitor",
  Mantis: "Molitor",
  Peppers: "Molitor",
  Swissotel: "Molitor",
  The_Sebel: "Molitor",
  "21C": "Molitor",
  "25_Hours": "Molitor",
  Hoxton: "Molitor",
  Hyde: "Molitor",
  Mondrian: "Molitor",

  Fairmont: "Sofitel",
  Sofitel: "Sofitel",
  MGallery: "MGallery",
  Banyan_Tree: "Sofitel",
  Delano: "Sofitel",
  Faena: "Sofitel",
  Gleneagles: "Sofitel",
  Our_Habitas: "Sofitel",
  Redbury_Hotels: "Sofitel",
  Rixos: "Sofitel",
  SLS: "Sofitel",
  So: "Sofitel",
  The_Originals: "Sofitel",
  Emblems: "Sofitel",
  Orient_Express: "Sofitel",
  Raffles: "Sofitel",
};

export const savingsRatesByHotel = {
  Greet: 32,
  "Ibis Styles": 33,
  Novotel: 35,
  MGallery: 38,
  Sofitel: 42,
  Molitor: 36,
};

export const waterConsumptionPerShowerByHotel = {
  Greet: 78,
  "Ibis Styles": 82,
  Novotel: 93,
  MGallery: 96,
  Sofitel: 101,
  Molitor: 112,
};
